module.exports = __webpack_public_path__ + "static/img/2.a0dd702.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/eng/2.png
// module id = /8pG
// module chunks = 0